module.exports = __webpack_public_path__ + "img/blue_151.5e5768f8.png";